import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as actionCreators from './actions';
import Loader from '../../shared/components/Loader/Loader';
const TravelDatesComp = React.lazy(() => import("./components/index"));
class TravelDatesContainer extends Component { // eslint-disable-line  
    componentDidMount() {
        this.props.actions.getSections();
      }
    render() {
        if (this.props.isFetching) {
            return <Loader />
        }
        return(
             <TravelDatesComp />
        )
    }
}
const mapStateToProps = (state) => {
        const data = state;
        return {
            isFetching: data.ITP_TravelDate.isFetching,
            travelData: data.travelData
        }
  };
  const mapDispatchToProps = dispatch => ({
      actions: bindActionCreators(actionCreators, dispatch)
  });
    
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TravelDatesContainer));
//export default TravelDatesContainer;